export class Document {

	id: string;
	title: string;
	description: string;
	document_text: string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}